export default __webpack_public_path__ + "static/media/title-menu-amorim.01c33686.png";